module.exports = __webpack_public_path__ + "img/ic_master_card.d1532830.png";